import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { InputError } from '@foodsby/nutrient'
import LocationSearchBox from './LocationSearchBox'
import { search, update } from '../../redux/modules/locationSearch'

class LocationSearchContainer extends Component {
  constructor(props) {
    super(props)
    this.state = {
      selectedLocation: '',
      selectDisabled: true
    }

    this.updateLocation = this.updateLocation.bind(this)
    this.handleChange = this.handleChange.bind(this)
  }

  updateLocation() {
    let currentUrl = window.location.href

    if (currentUrl.includes('?newLocationId')) {
      let newUrl = currentUrl.split('=')[0] + '=' + this.state.selectedLocation
      window.location.href = newUrl
    } else {
      window.location.href = `${currentUrl}?newLocationId=${
        this.state.selectedLocation
      }`
    }
  }

  handleChange(e) {
    this.setState({ selectedLocation: e.target.value })
    if (e.target.value === 'search-location') {
      this.setState({ selectDisabled: true })
    } else {
      this.setState({ selectDisabled: false })
    }
  }

  render() {
    const {
      error,
      address,
      update,
      search,
      redirectOverride,
      submitting,
      locationError,
      showError,
      multipleLocations
    } = this.props
    return (
      <div>
        <LocationSearchBox
          updateAddress={update}
          search={search}
          redirectOverride={redirectOverride}
          address={address}
          submitting={submitting}
          showError={showError}
        />{' '}
        {error && !locationError ? (
          <div className="center-xs pt-1">
            <InputError visible={error || locationError !== null}>
              {error.message
                ? error.message
                : 'Address not found. Please enter a valid address.'}
            </InputError>
          </div>
        ) : locationError && !error ? (
          <div className="center-xs pt-1">
            <InputError visible={locationError && locationError !== null}>
              {locationError ||
                'Address not found. Please enter a valid address.'}
            </InputError>
          </div>
        ) : null}
        {multipleLocations ? (
          <div className="row center-xs">
            <div className="col-xs-12">
              <label style={{ textAlign: 'left' }}>
                Please select your specific location below
              </label>
              <select onChange={this.handleChange}>
                <option value="search-location">---</option>
                {this.props.locationSearch.locations.foundLocations.map(
                  location => {
                    return (
                      <option key={location.id} value={location.id}>
                        {location.name}
                      </option>
                    )
                  }
                )}
              </select>
              <button
                type="submit"
                className="locationsearch-button"
                disabled={this.state.selectDisabled}
                onClick={() => this.updateLocation()}
              >
                Select
              </button>
            </div>
          </div>
        ) : null}
      </div>
    )
  }
}

function mapStateToProps(state) {
  const { address = '', submitting, error } = state.locationSearch
  const locationSearch = state.locationSearch

  return {
    address,
    error,
    submitting,
    locationSearch
  }
}

const mapDispatchToProps = {
  update,
  search
}

LocationSearchContainer.propTypes = {
  loading: PropTypes.bool
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LocationSearchContainer)
